<app-window-title [closable]="true"
                  [title]="title"></app-window-title>

<!-- Action buttons -->
<div class="action-buttons">
  <button mat-icon-button
          matTooltip="Download"
          [disabled]="error"
          (click)="downloadDocument()">
    <mat-icon>
      download
    </mat-icon>
  </button>
  <button mat-icon-button
          matTooltip="Print"
          [disabled]="error"
          (click)="printDocument()">
    <mat-icon>
      print
    </mat-icon>
  </button>
  <button *ngIf="!isPDF()"

          mat-icon-button
          matTooltip="Print as PDF"

          [disabled]="error || isPDF()"
          (click)="printAsPDF()">
    <mat-icon>
      picture_as_pdf
    </mat-icon>
  </button>
</div>

<!-- Metadata panel -->
<div *ngIf="docViewerLoaded && !error"
     class="metadata-panel">
  <div class="metadata-content">
    <div class="metadata-item">
      <mat-icon class="metadata-icon">
        description
      </mat-icon>
      <span class="metadata-label">
        File Name:
      </span>
      <span class="metadata-value">
        {{getFileName()}}
      </span>
    </div>
    <div class="metadata-item">
      <mat-icon class="metadata-icon">
        category
      </mat-icon>
      <span class="metadata-label">
        Type:
      </span>
      <span class="metadata-value">
        {{getFileType()}}
      </span>
    </div>
    <div *ngIf="getFileSize()"
         class="metadata-item">
      <mat-icon class="metadata-icon">
        storage
      </mat-icon>
      <span class="metadata-label">
        Size:
      </span>
      <span class="metadata-value">
        {{getFileSize()}}
      </span>
    </div>
    <div *ngIf="info?.lastModified"
         class="metadata-item">
      <mat-icon class="metadata-icon">
        schedule
      </mat-icon>
      <span class="metadata-label">
        Last Modified:
      </span>
      <span class="metadata-value">
        {{formatDate(info.lastModified)}}
      </span>
    </div>
  </div>
</div>

<div class="doc-viewer-container">
  <!-- Video viewer -->
  <video *ngIf="viewer === 'video'"
         class="video-viewer"
         controls
         (error)="handleError($event)">
    <source src="{{ src }}"
            type="video/mp4">
    Your browser does not support the video tag.
  </video>

  <!-- Image viewer -->
  <div *ngIf="viewer === 'url'"
       class="image-container"
       (contextmenu)="preventContextMenu($event)">
    <img class="image-viewer"

         [alt]="title"
         [src]="src"

         (contextmenu)="preventContextMenu($event)"
         (error)="handleError($event)">
  </div>

  <!-- Document viewer -->
  <div *ngIf="viewer !== 'video' && viewer !== 'url'"
       class="document-container">
    <ngx-doc-viewer class="viewer"

                    [ngClass]="{ 'hidden': !docViewerLoaded }"
                    [url]="src"
                    [viewer]="viewer"

                    (error)="handleError($event)"
                    (loaded)="onDocumentLoaded($event)">
    </ngx-doc-viewer>

    <!-- Loading state -->
    <app-loader *ngIf="!docViewerLoaded"
                class="loader"
                message="Loading document...">
    </app-loader>

    <!-- Error state -->
    <div *ngIf="error"
         class="error-container">
      <mat-icon class="error-icon">
        error_outline
      </mat-icon>
      <p class="error-message">
        {{error}}
      </p>
      <button color="warn"
              mat-flat-button
              (click)="retryLoading()">
        Retry
      </button>
    </div>
  </div>
</div>
